import { Link, useNavigate } from 'react-router-dom';
import { connect } from "react-redux"
import { useEffect, useState } from 'react'
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { MapContainer, TileLayer, Marker} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import axios from 'axios';

function TripInfo({
  slug,
  isAuthenticated,
  user,
}) {

  const navigate = useNavigate();

  const [trip, setTrip] = useState({});
  const [open, setOpen] = useState(false)
  const [open1, setOpen1] = useState(false)
  const [open2, setOpen2] = useState(false)
  const [open3, setOpen3] = useState(false)

  //FORMATEO FECHA
  const formatFecha = (fecha) => {
    if (!fecha) return '';

    const date = new Date(fecha);
    const options = { day: 'numeric', month: 'short' };

    return date.toLocaleDateString('es-ES', options);
  }

  const customHoverMarkerIcon = L.divIcon({
        html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-8">
                  <path fill-rule="evenodd" d="m11.54 22.351.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.975 16.975 0 0 0 1.144-.742 19.58 19.58 0 0 0 2.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 0 0-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 0 0 2.682 2.282 16.975 16.975 0 0 0 1.145.742ZM12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" clip-rule="evenodd" />
                </svg>
              `,
        className: "text-blue-green",
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [0, -32]
  });

  const reservar_trip = async (slug) => {
    if (localStorage.getItem('access')) {

      const config = {
          headers: {
              'Authorization': `JWT ${localStorage.getItem('access')}`,
              'Accept': 'application/json'
          }
      };

      try {
          const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/trip/reservar/${slug}`, {}, config);
          if (res.status === 200) {
            await get_trip(slug)
          } else {
          }
      } catch (err) {
      } finally {
        setOpen3(false)
      }
    }else{
      setOpen3(false)
    }
  }

  const cancelar_reserva_trip = async (slug) => {
    if (localStorage.getItem('access')) {

      const config = {
          headers: {
              'Authorization': `JWT ${localStorage.getItem('access')}`,
              'Accept': 'application/json'
          }
      };

      try {
          const res = await axios.delete(`${process.env.REACT_APP_API_URL}/api/trip/reservar/${slug}`, config);
          if (res.status === 200) {
            await get_trip(slug)
          } else {
          }
      } catch (err) {
      } finally {
        setOpen2(false)
      }
    }else{
      setOpen2(false)
    }
  }

  const delete_trip = async (slug) => {
    if (localStorage.getItem('access')) {

      const config = {
          headers: {
              'Authorization': `JWT ${localStorage.getItem('access')}`,
              'Accept': 'application/json'
          }
      };

      try {
          const res = await axios.delete(`${process.env.REACT_APP_API_URL}/api/trip/detail/${slug}`, config);
          if (res.status === 200) {
            navigate('/');
          } else {
          }
      } catch (err) {
      } finally {
        setOpen1(false)
      }
    }else{
      setOpen1(false)
    }
  }

  const get_trip = async (slug) => {

    let config = {}
    if (localStorage.getItem('access')) {
      config = {
        headers: {
            'Authorization': `JWT ${localStorage.getItem('access')}`,
            'Accept': 'application/json'
        }
      };
    }else{
      config = {
        headers: {
            'Accept': 'application/json'
        }
      };
    }

    try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/trip/detail/${slug}`, config);
        if (res.status === 200) {
            setTrip(res.data.trip)
        } else {
            setTrip({})
        }
    } catch (err) {
        setTrip({})
    } finally {
    }
  }

  useEffect(()=>{
    get_trip(slug)
  }, [])

  return (
    <div>
      <h1 className='mt-10 mx-auto max-w-6xl px-4 font-bold text-4xl md:text-5xl'>
        {trip.event?.title}, 
        {formatFecha(trip.event?.fecha)}
      </h1>

      <div className='mt-10 md:flex gap-x-12 mx-4 md:mx-10 lg:mx-auto max-w-6xl pb-5'>
        
        <div className='flex-[4]'>

          <div className="bg-white border rounded-t-3xl p-6 shadow-md">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Resumen del viaje</h1>

            <div className='flex items-center gap-x-4'>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 text-blue-green">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
              </svg>

              {trip.pickup_time?.slice(0,5)} 
            </div>
              
            <div className='flex items-center gap-x-4 my-2'>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 text-blue-green">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
              </svg>
              {trip.pickup_location?.address}

            </div>
      
            <div className='flex items-center gap-x-4'>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 text-blue-green">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 3v1.5M3 21v-6m0 0 2.77-.693a9 9 0 0 1 6.208.682l.108.054a9 9 0 0 0 6.086.71l3.114-.732a48.524 48.524 0 0 1-.005-10.499l-3.11.732a9 9 0 0 1-6.085-.711l-.108-.054a9 9 0 0 0-6.208-.682L3 4.5M3 15V4.5" />
              </svg>

              {trip.event?.recinto.name}
            </div>

          </div>

          <div className='rounded-b-3xl shadow-md overflow-hidden'>
            {trip && Object.keys(trip).length > 0 ? 
            <MapContainer center={[trip.pickup_location?.latitude, trip.pickup_location?.longitude]} zoom={14} style={{ height: "40vh", width: "100%",  position: "relative", zIndex: 1}} >
                  <TileLayer
                      url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                  />
                  <Marker 
                    position={[trip.pickup_location?.latitude, trip.pickup_location?.longitude]} 
                    icon={customHoverMarkerIcon}
                  />
              </MapContainer>
              :(
                null
              )}
          </div>

          <div className='bg-white mt-6 border rounded-3xl p-6 shadow-md'>
            <h1 className="text-2xl font-bold text-gray-900">Conductor</h1>
            <div className="mt-4 flex gap-x-4">
                  <img alt="Conductor" src={`${trip.creator?.profile_picture}`} className="h-12 w-12 flex-none rounded-full bg-gray-50" />
                  <div className="min-w-0 flex-auto">
                    <p className="text-sm font-semibold leading-6 text-gray-900">{trip.creator?.first_name} {trip.creator?.last_name} {trip.creator?.second_last_name}</p>
                    <p className="text-xs text-gray-500">Conductor</p>
                  </div>
            </div>

            <div className="px-4 py-4">
              <p className="text-sm font-medium leading-6 text-gray-900">Notas</p>
              <p className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                {trip.notes}
              </p>
            </div>
          </div>

        </div>

        <div className="flex-[2]">
          <div className='mt-5 md:mt-0 sticky top-24 bg-white border shadow-md rounded-3xl p-6'>
            <h1 className="text-2xl font-bold text-gray-900">Pasajeros</h1>

            {trip && trip.passengers?.length > 0 ? (
              <ul role="list" className="mt-5">
                {trip&&trip.passengers.map((passenger, index) => (
                    <li key={index} className="flex justify-between gap-x-6 py-5">
                      <div className="flex min-w-0 gap-x-4">
                        <img alt="" src={`${passenger.profile_picture}`} className="h-12 w-12 flex-none rounded-full bg-gray-50" />
                        <div className="min-w-0 flex-auto">
                          <p className="text-sm font-semibold leading-6 text-gray-900">{passenger.first_name} {passenger.last_name} {passenger.second_last_name}</p>
                          <p className="text-xs text-gray-700">@instagram</p>
                        </div>
                      </div>
                    </li>
                ))}
              </ul>
            ):
              <h2 className="text-center mt-6 text-md leading-7 text-gray-900">Este viaje aún no tiene reservas</h2>
            }

            { trip?.creator_me ? 
              <>
              <h2 className="mt-10 border-t border-gray-200 pt-3 text-xl leading-7 text-gray-900">Plazas libres: {trip?.available_seats}</h2>
              <div className='mt-5'>
                <button
                  type="button"
                  onClick={() => setOpen1(true)}
                  className="w-full rounded-3xl bg-red-800 px-3 py-4 text-xl font-bold text-white hover:bg-red-900"
                >
                  Eliminar Trip 
                </button>
              </div>
              </>
              : trip?.booked ?
              <>
              <h2 className="mt-10 border-t border-gray-200 pt-3 text-xl leading-7 text-gray-900">Plazas libres: {trip?.available_seats}</h2>
              <div className='mt-5'>
                <button
                  type="button"
                  onClick={() => setOpen2(true)}
                  className="w-full rounded-3xl bg-gray-400 px-3 py-4 text-xl font-bold text-white hover:bg-gray-500"
                >
                  Cancelar reserva
                </button>
              </div>
              </> :
              trip?.available_seats > 0 ? 
                <>
                <h2 className="mt-10 border-t border-gray-200 pt-3 text-xl leading-7 text-gray-900">Plazas libres: {trip?.available_seats}</h2>
                <div className='mt-5'>
                  <button
                    type="button"
                    onClick={() => setOpen3(true)}
                    className="w-full rounded-3xl bg-blue-green px-3 py-4 text-xl font-bold text-white hover:bg-blue-green-dark"
                  >
                    Reservar 
                  </button>
                </div>
                </> :
                <h2 className="mt-5 border-t border-gray-200 pt-3 text-xl leading-7 text-gray-900">Este viaje esta completo</h2>
            }
          </div>
        </div>
      </div>

        { isAuthenticated ? (
          <>
          <Dialog open={open1} onClose={()=> setOpen1(false)} className="relative z-10">
          <DialogBackdrop
            transition
            className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
          />

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <DialogPanel
                transition
                className="relative transform overflow-hidden rounded-3xl bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
              >
                <div className='p-5 text-center'>
                  <h1 className='text-2xl font-semibold'>¿Quieres eliminar este trip?</h1>
                  <p className='font-semibold text-gray-500 mt-2'>Al eliminar el trip desaparecerá de la plataforma y los pasajeros que habian reservado serán expulsados</p>
                  <div className='mt-4 flex gap-x-4 justify-center items-center'>
                    <button onClick={() => setOpen1(false)} className='px-4 py-2 bg-gray-300 hover:bg-gray-400 hover:text-white rounded-3xl'>Cancelar</button>
                    <button type='button' onClick={() => delete_trip(slug)} className='px-4 py-2 bg-red-800 hover:bg-red-900 text-white rounded-3xl'>Eliminar</button>
                  </div>
                </div>
               
              </DialogPanel>
            </div>
          </div>
          </Dialog>

          <Dialog open={open2} onClose={()=> setOpen2(false)} className="relative z-10">
          <DialogBackdrop
            transition
            className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
          />

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <DialogPanel
                transition
                className="relative transform overflow-hidden rounded-3xl bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
              >
                <div className='p-5 text-center'>
                  <h1 className='text-2xl font-semibold'>¿Quieres cancelar tu reserva?</h1>
                  <p className='font-semibold text-gray-500 mt-2'>Al cancelar la reserva renuncias a tu plaza en el trip quedando fuera de este</p>
                  <div className='mt-4 flex gap-x-4 justify-center items-center'>
                    <button onClick={() => setOpen2(false)} className='px-4 py-2 bg-gray-300 hover:bg-gray-400 hover:text-white rounded-3xl'>Cancelar</button>
                    <button type='button' onClick={() => cancelar_reserva_trip(slug)} className='px-4 py-2 bg-green-800 hover:bg-green-900 text-white rounded-3xl'>Confirmar</button>
                  </div>
                </div>
               
              </DialogPanel>
            </div>
          </div>
          </Dialog>
         
          <Dialog open={open3} onClose={()=> setOpen3(false)} className="relative z-10">
          <DialogBackdrop
            transition
            className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
          />

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <DialogPanel
                transition
                className="relative transform overflow-hidden rounded-3xl bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
              >
                <div className='p-5 text-center'>
                  <h1 className='text-2xl font-semibold'>¿Quieres reservar este trip?</h1>
                  <p className='font-semibold text-gray-500 mt-2'>Al reservar el trip formarás parte del viaje</p>
                  <div className='mt-4 flex gap-x-4 justify-center items-center'>
                    <button onClick={() => setOpen3(false)} className='px-4 py-2 bg-gray-300 hover:bg-gray-400 hover:text-white rounded-3xl'>Cancelar</button>
                    <button onClick={()=>reservar_trip(slug)} className='px-4 py-2 bg-blue-green hover:bg-blue-green-dark text-white rounded-3xl'>Reservar</button>
                  </div>
                </div>
              </DialogPanel>
            </div>
          </div>
          </Dialog>
          </>
        ):(
          <Dialog open={open3} onClose={()=> setOpen3(false)} className="relative z-10">
          <DialogBackdrop
            transition
            className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
          />

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <DialogPanel
                transition
                className="relative transform overflow-hidden rounded-3xl bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
              >

                <div className='py-5 px-5 text-center'>
                  <h1 className='text-xl md:text-2xl font-semibold mb-5'>Inicia sesión para reservar trips</h1>
                  <Link 
                    to='/login'
                    className="rounded-3xl px-4 py-2 bg-blue-green hover:bg-blue-green-dark text-white ">
                    Iniciar sesion
                  </Link>
                </div>
                
              </DialogPanel>
            </div>
          </div>
          </Dialog>
          )
        }
    </div>
  )
}

const mapStateToProps=state=>({
  isAuthenticated: state.auth.isAuthenticated,
  user: state.auth.user
})

export default connect (mapStateToProps, {
})(TripInfo)
